import { createOrganisation } from '@infuse/api/iam/organisation';
import { useGenericCreateOrganisation } from './generic/useGenericCreateOrganisation';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { createTenantOrganisation } from '@infuse/api/iam/tenant';

export const useCreateOrganisation = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.TENANT) {
    return useGenericCreateOrganisation({
      apiFn: createTenantOrganisation,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericCreateOrganisation({
    apiFn: createOrganisation
  });
};
